import React, { useEffect, useState, useMemo } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import { Link } from "react-router-dom";

const FORMA_PAGO_MAP = {
    '10': 'Efectivo',
    '42': 'Consignación bancaria',
    '1': 'Instrumento no definido',
    '20': 'Cheque',
    '30': 'Transferencia Crédito',
    '31': 'Transferencia Débito',
    '45': 'Transferencia Crédito Bancario',
    '47': 'Transferencia Débito Bancaria',
    '48': 'Tarjeta Crédito',
    '49': 'Tarjeta Débito',
    ZZZ: 'Acuerdo mutuo'
};

function ReporteFacturacion() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);
    const [facturas, setFacturas] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [pacientes, setPacientes] = useState([]);

    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [busquedaDocumento, setBusquedaDocumento] = useState('');
    const [numeroFactura, setNumeroFactura] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [tipoFacturaFiltro, setTipoFacturaFiltro] = useState('');
    const [historicoCompleto, setHistoricoCompleto] = useState(false);

    const totalesResumen = useMemo(() => {
        let totalFacturado = 0;
        let totalCobrado = 0;
        let totalPendiente = 0;
        for (const f of facturas) {
            const estado = parseInt(f.estado, 10);
            if (estado === 3) continue;
            const vt = parseFloat(f.valor_total) || 0;
            const tipoPago = String(f.tipo_pago || '').toLowerCase();
            const pendienteField = parseFloat(f.valor_pendiente);
            totalFacturado += vt;
            const esContado = tipoPago === 'contado' || [1, 4].includes(estado);
            if (esContado) {
                totalCobrado += vt;
            } else {
                let p = Number.isFinite(pendienteField) ? pendienteField : vt;
                if (p < 0) p = 0;
                if (p > vt) p = vt;
                totalPendiente += p;
                totalCobrado += vt - p;
            }
        }
        return {
            total_facturas: facturas.length,
            total_facturado: totalFacturado,
            total_cobrado: totalCobrado,
            total_pendiente: totalPendiente
        };
    }, [facturas]);

    const formatearMonedaResumen = (valor) =>
        '$' + Number(valor || 0).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

    useEffect(() => {
        console.log('ReporteFacturacion: useEffect iniciado');
        
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        console.log('ReporteFacturacion: userdata cargado', userdata);

        // 🔒 VALIDACIÓN DE PERMISOS - Patrón híbrido (nuevo + legacy)
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'ver_listado_facturas');
        } else if (userdata.up && userdata.up.includes('ver_listado_facturas')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            console.log('ReporteFacturacion: Sin permisos');
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        console.log('ReporteFacturacion: Con permisos, cargando datos');
        setHasPermission(true);

        // Fechas por defecto: semana actual (igual que listado)
        const hoy = new Date();
        const inicioSemana = new Date(hoy);
        inicioSemana.setDate(hoy.getDate() - hoy.getDay());
        const finSemana = new Date(inicioSemana);
        finSemana.setDate(inicioSemana.getDate() + 6);
        setFechaInicio(inicioSemana.toISOString().split('T')[0]);
        setFechaFin(finSemana.toISOString().split('T')[0]);

        // ✅ Sin config manual - el interceptor agrega el token automáticamente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                console.log('ReporteFacturacion: Cliente cargado', response.data);
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('ReporteFacturacion: Error cargando cliente', error);
                setLoggedIn(true);
            });

        // Cargar usuarios del cliente
        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                console.log('ReporteFacturacion: Usuarios cargados', response.data);
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando usuarios (puede ser por permisos):', error.response?.status);
                setUsuarios([]);
            });

        // Cargar pacientes
        axios.get('/pacientes', { 
            params: { 
                uid: userdata.user_id
            }
        })
            .then(response => {
                console.log('ReporteFacturacion: Pacientes cargados', response.data);
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando pacientes: ' + error);
            });
    }, []);

    // Ejecutar búsqueda automáticamente al cambiar filtros (igual que listado)
    useEffect(() => {
        if (loggedIn && (historicoCompleto || (fechaInicio && fechaFin))) {
            cargarReporte();
        }
    }, [loggedIn, historicoCompleto, fechaInicio, fechaFin, usuarioFiltro, filtroEstado, tipoFacturaFiltro, numeroFactura, busquedaPaciente, busquedaDocumento]);

    const cargarReporte = () => {
        if (!historicoCompleto && (!fechaInicio || !fechaFin)) {
            alert('Seleccione fecha inicio y fecha fin, o active "Histórico completo".');
            return;
        }

        setLoading(true);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const fechaInicioConsulta = historicoCompleto ? '1990-01-01' : fechaInicio;
        const fechaFinConsulta = historicoCompleto ? '3000-12-31' : fechaFin;
        
        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicioConsulta,
            fecha_fin: fechaFinConsulta
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaPaciente) params.append('busqueda_paciente', busquedaPaciente);
        if (busquedaDocumento) params.append('busqueda_documento', busquedaDocumento);
        if (numeroFactura) params.append('numero_factura', numeroFactura);
        if (tipoFacturaFiltro) params.append('tipo_factura', tipoFacturaFiltro);

        if (filtroEstado === 'contado') {
            params.append('tipo_pago', 'contado');
        } else if (filtroEstado === 'credito') {
            params.append('tipo_pago', 'credito');
        } else if (filtroEstado !== '') {
            params.append('estado', filtroEstado);
        }

        axios.get('/facturas?' + params.toString())
            .then(response => {
                setFacturas(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('ReporteFacturacion: Error cargando facturas', error);
                setLoading(false);
            });
    };

    const handleLimpiarFiltros = () => {
        const hoy = new Date();
        const inicioSemana = new Date(hoy);
        inicioSemana.setDate(hoy.getDate() - hoy.getDay());
        const finSemana = new Date(inicioSemana);
        finSemana.setDate(inicioSemana.getDate() + 6);

        setFechaInicio(inicioSemana.toISOString().split('T')[0]);
        setFechaFin(finSemana.toISOString().split('T')[0]);
        setUsuarioFiltro('');
        setBusquedaPaciente('');
        setBusquedaDocumento('');
        setNumeroFactura('');
        setFiltroEstado('');
        setTipoFacturaFiltro('');
        setHistoricoCompleto(false);
        setTimeout(() => cargarReporte(), 100);
    };

    const getPaciente = (pacienteId) => pacientes.find(p => p.id == pacienteId);

    const getNombrePaciente = (pacienteId) => {
        const paciente = getPaciente(pacienteId);
        if (paciente) {
            return `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        }
        return 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        if (usuarios.length === 0) {
            return `Usuario ${usuarioId}`;
        }
        const usuario = usuarios.find(u => u.id == usuarioId);
        return usuario ? usuario.name : `Usuario ${usuarioId}`;
    };

    const getDocumentoPaciente = (pacienteId) => getPaciente(pacienteId)?.numero_documento || 'N/A';

    const getContactoPaciente = (pacienteId) => {
        const paciente = getPaciente(pacienteId);
        return paciente?.celular || paciente?.telefono || 'N/A';
    };

    const getEmailPaciente = (pacienteId) => getPaciente(pacienteId)?.email || 'N/A';

    const getFormaPagoTexto = (formaPago) => {
        if (formaPago === null || formaPago === undefined || formaPago === '') return 'N/A';
        const key = String(formaPago).trim();
        return FORMA_PAGO_MAP[key] || formaPago;
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Cobrada';
            case 2: return 'Por Cobrar';
            case 3: return 'Anulada';
            case 4: return 'Cobrada';
            case 5: return 'Por Cobrar';
            case 6: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const getEstadoChipClass = (estado) => {
        const e = parseInt(estado, 10);
        switch (e) {
            case 1:
            case 4:
                return 'report-chip report-chip--ok';
            case 2:
            case 5:
                return 'report-chip report-chip--warn';
            case 3:
            case 6:
                return 'report-chip report-chip--bad';
            case 0:
            default:
                return 'report-chip report-chip--neutral';
        }
    };

    const getDianChipClass = (estado) => {
        const e = parseInt(estado, 10);
        if ([1, 2, 3].includes(e)) return 'report-chip report-chip--ok';
        if ([4, 5].includes(e)) return 'report-chip report-chip--warn';
        return 'report-chip report-chip--neutral';
    };

    const exportarExcel = () => {
        if (facturas.length === 0) {
            alert('No hay datos para exportar');
            return;
        }

        import('xlsx').then(XLSX => {
            const datosExcel = facturas.map(f => ({
                'Prefijo': f.prefijo || '',
                'N° Factura': f.numero_factura || f.consecutivo || '',
                'Tipo': f.tipo_factura === 'no_electronica' || [4, 5].includes(f.estado) ? 'No Elect.' : 'Elect.',
                'Fecha': new Date(f.fecha_emision).toLocaleDateString(),
                'Paciente': getNombrePaciente(f.paciente_id),
                'Documento Paciente': getDocumentoPaciente(f.paciente_id),
                'Contacto': getContactoPaciente(f.paciente_id),
                'Correo': getEmailPaciente(f.paciente_id),
                'Profesional': getNombreUsuario(f.users_id),
                'Valor Bruto': f.valor_bruto || 0,
                'Total': f.valor_total || 0,
                'Por Cobrar': (f.estado === 2 || f.estado === 5) ? (f.valor_pendiente || f.valor_total) : 0,
                'Tipo Pago': f.tipo_pago || '',
                'Forma Pago': getFormaPagoTexto(f.forma_pago),
                'DIAN': [1, 2, 3].includes(f.estado) ? 'ENVIADO' : [4, 5].includes(f.estado) ? 'NO APLICA' : 'NO ENVIADO',
                'Estado': getEstadoTexto(f.estado)
            }));

            const ws = XLSX.utils.json_to_sheet(datosExcel);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Facturacion");
            const fecha = new Date().toISOString().split('T')[0];
            XLSX.writeFile(wb, `reporte_facturacion_${fecha}.xlsx`);
        }).catch(() => {
            // Fallback a CSV si XLSX falla
            exportarCSV();
        });
    };

    const exportarCSV = () => {
        if (facturas.length === 0) {
            alert('No hay datos para exportar');
            return;
        }

        const headers = ['Prefijo', 'N° Factura', 'Tipo', 'Fecha', 'Paciente', 'Documento Paciente', 'Contacto', 'Correo', 'Profesional', 'Valor Bruto', 'Total', 'Por Cobrar', 'Tipo Pago', 'Forma Pago', 'DIAN', 'Estado'];
        const csvContent = [
            headers.join(','),
            ...facturas.map(f => [
                f.prefijo || '',
                f.numero_factura || f.consecutivo || '',
                f.tipo_factura === 'no_electronica' || [4, 5].includes(f.estado) ? 'No Elect.' : 'Elect.',
                new Date(f.fecha_emision).toLocaleDateString(),
                `"${getNombrePaciente(f.paciente_id)}"`,
                `"${getDocumentoPaciente(f.paciente_id)}"`,
                `"${getContactoPaciente(f.paciente_id)}"`,
                `"${getEmailPaciente(f.paciente_id)}"`,
                `"${getNombreUsuario(f.users_id)}"`,
                f.valor_bruto || 0,
                f.valor_total || 0,
                (f.estado === 2 || f.estado === 5) ? (f.valor_pendiente || f.valor_total) : 0,
                f.tipo_pago || '',
                `"${getFormaPagoTexto(f.forma_pago)}"`,
                [1, 2, 3].includes(f.estado) ? 'ENVIADO' : [4, 5].includes(f.estado) ? 'NO APLICA' : 'NO ENVIADO',
                getEstadoTexto(f.estado)
            ].join(','))
        ].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `reporte_facturacion_${new Date().toISOString().split('T')[0]}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (hasPermission === false) return <Unauthorized />;
    if (!loggedIn) return <Loading />;

    return (
        <div className="hold-transition" style={{ fontSize: '13px' }}>
            <Header client={client} />
            <Aside client={client} activelink="reports" />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                    <li className="breadcrumb-item">Reporte de Facturación</li>
                                </ol>
                            </div>
                        </div>
                        <h1 className="m-0">Reporte de Facturación</h1>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        {/* FILTROS */}
                        <div className="card report-fin-card">
                            <div className="card-header">
                                <h3 className="card-title">Filtros de Búsqueda</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="fechaInicio">Fecha Inicio</label>
                                            <input 
                                                type="date" 
                                                className="form-control form-control-sm"
                                                id="fechaInicio"
                                                value={fechaInicio}
                                                disabled={historicoCompleto}
                                                onChange={e => setFechaInicio(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="fechaFin">Fecha Fin</label>
                                            <input 
                                                type="date" 
                                                className="form-control form-control-sm"
                                                id="fechaFin"
                                                value={fechaFin}
                                                disabled={historicoCompleto}
                                                onChange={e => setFechaFin(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="usuarioFiltro">Profesional</label>
                                            <select className="form-control form-control-sm" id="usuarioFiltro" value={usuarioFiltro} onChange={e => setUsuarioFiltro(e.target.value)}>
                                                <option value="">Todos</option>
                                                {usuarios.map(usuario => (
                                                    <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="filtroEstado">Estado</label>
                                            <select className="form-control form-control-sm" id="filtroEstado" value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
                                                <option value="">Todos</option>
                                                <option value="contado">Contado</option>
                                                <option value="credito">Crédito</option>
                                                <option value="pendientes_envio">Pendiente envío</option>
                                                <option value="pendientes_pago">Pendiente pago</option>
                                                <option value="contabilidad">Contabilidad</option>
                                                <option value="3">Anuladas</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="tipoFacturaFiltro">Tipo Factura</label>
                                            <select className="form-control form-control-sm" id="tipoFacturaFiltro" value={tipoFacturaFiltro} onChange={e => setTipoFacturaFiltro(e.target.value)}>
                                                <option value="">Todas</option>
                                                <option value="electronica">Electrónica</option>
                                                <option value="no_electronica">No Electrónica</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label htmlFor="numeroFactura">Nro. Factura</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="numeroFactura"
                                                placeholder="Nro..."
                                                value={numeroFactura}
                                                onChange={e => setNumeroFactura(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="busquedaPaciente">Paciente</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="busquedaPaciente"
                                                placeholder="Buscar por nombre..."
                                                value={busquedaPaciente}
                                                onChange={e => setBusquedaPaciente(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="busquedaDocumento">Identificación</label>
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="busquedaDocumento"
                                                placeholder="Cédula, NIT o documento..."
                                                value={busquedaDocumento}
                                                onChange={e => setBusquedaDocumento(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="d-block">Opciones</label>
                                            <div className="form-check mt-1">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="historicoCompleto"
                                                    checked={historicoCompleto}
                                                    onChange={(e) => setHistoricoCompleto(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="historicoCompleto">
                                                    Histórico completo (sin límite de fechas)
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm mr-2"
                                            onClick={cargarReporte}
                                            disabled={loading}
                                        >
                                            <i className="fas fa-search"></i> Buscar
                                            {loading && <span className="spinner-border spinner-border-sm ml-2"></span>}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-sm mr-2"
                                            onClick={handleLimpiarFiltros}
                                        >
                                            <i className="fas fa-eraser"></i> Limpiar Filtros
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm mr-2"
                                            onClick={exportarExcel}
                                            disabled={facturas.length === 0}
                                            title="Exportar datos a Excel (o CSV si Excel no está disponible)"
                                        >
                                            <i className="fas fa-file-excel"></i> Excel
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-info btn-sm"
                                            onClick={exportarCSV}
                                            disabled={facturas.length === 0}
                                            title="Exportar datos a CSV"
                                        >
                                            <i className="fas fa-file-csv"></i> CSV
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3">
                                <div className="card card-outline card-secondary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{totalesResumen.total_facturas}</h3>
                                                <p className="text-muted mb-0 small">Total facturas (listado)</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(108, 117, 125, 0.12)', color: '#6c757d' }}>
                                                <i className="fas fa-file-invoice"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-secondary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMonedaResumen(totalesResumen.total_facturado)}</h3>
                                                <p className="text-muted mb-0 small">Total facturado</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(23, 162, 184, 0.12)', color: '#17a2b8' }}>
                                                <i className="fas fa-dollar-sign"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-success">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMonedaResumen(totalesResumen.total_cobrado)}</h3>
                                                <p className="text-muted mb-0 small">Total pagados</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(40, 167, 69, 0.10)', color: '#28a745' }}>
                                                <i className="fas fa-check-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-warning">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMonedaResumen(totalesResumen.total_pendiente)}</h3>
                                                <p className="text-muted mb-0 small">Total por cobrar</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(250, 173, 20, 0.14)', color: '#d97706' }}>
                                                <i className="fas fa-clock"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* TABLA DE RESULTADOS */}
                        <div className="card report-fin-card">
                            <div className="card-header">
                                <h3 className="card-title">
                                    Resultados ({facturas.length} facturas encontradas)
                                </h3>
                            </div>
                            <div className="card-body p-0">
                                {loading ? (
                                    <div className="text-center py-4">
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                        <table className="table table-bordered table-hover mb-0 report-fin-table" style={{ minWidth: '1800px' }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ minWidth: '120px', textAlign: 'center' }}>N° Factura</th>
                                                    <th style={{ minWidth: '80px', textAlign: 'center' }}>Tipo</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center' }}>Fecha</th>
                                                    <th style={{ minWidth: '180px', textAlign: 'center' }}>Paciente</th>
                                                    <th style={{ minWidth: '110px', textAlign: 'center' }}>Documento</th>
                                                    <th style={{ minWidth: '120px', textAlign: 'center' }}>Contacto</th>
                                                    <th style={{ minWidth: '200px', textAlign: 'center' }}>Correo</th>
                                                    <th style={{ minWidth: '150px', textAlign: 'center' }}>Profesional</th>
                                                    <th style={{ minWidth: '110px', textAlign: 'center' }}>Valor Bruto</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center' }}>Total</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center' }}>Por Cobrar</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center' }}>Tipo Pago</th>
                                                    <th style={{ minWidth: '170px', textAlign: 'center' }}>Forma Pago</th>
                                                    <th style={{ minWidth: '80px', textAlign: 'center' }}>DIAN</th>
                                                    <th style={{ minWidth: '100px', textAlign: 'center' }}>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {facturas.length > 0 ? facturas.map((factura, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            {(factura.tipo_factura === 'electronica' || [0, 1, 2, 3].includes(factura.estado)) && factura.prefijo ? (
                                                                <strong>{factura.prefijo}-{factura.numero_factura}</strong>
                                                            ) : (
                                                                <strong>{factura.numero_factura}</strong>
                                                            )}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={`report-chip ${factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado)
                                                                ? 'report-chip--type-no-elect'
                                                                : 'report-chip--type-elect'
                                                                }`}>
                                                                <i className={`fas ${factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado)
                                                                    ? 'fa-file-alt'
                                                                    : 'fa-bolt'
                                                                    } mr-1`}></i>
                                                                {
                                                                    factura.tipo_factura === 'no_electronica' || [4, 5].includes(factura.estado)
                                                                        ? 'No Elect.'
                                                                        : 'Elect.'
                                                                }
                                                            </span>
                                                        </td>
                                                        <td>{new Date(factura.fecha_emision).toLocaleDateString()}</td>
                                                        <td style={{ wordWrap: 'break-word' }}>
                                                            <span title={getNombrePaciente(factura.paciente_id)}>
                                                                {getNombrePaciente(factura.paciente_id).length > 25
                                                                    ? getNombrePaciente(factura.paciente_id).substring(0, 25) + '...'
                                                                    : getNombrePaciente(factura.paciente_id)
                                                                }
                                                            </span>
                                                        </td>
                                                        <td>{getDocumentoPaciente(factura.paciente_id)}</td>
                                                        <td>{getContactoPaciente(factura.paciente_id)}</td>
                                                        <td style={{ wordBreak: 'break-all' }}>{getEmailPaciente(factura.paciente_id)}</td>
                                                        <td style={{ wordWrap: 'break-word' }}>{getNombreUsuario(factura.users_id)}</td>
                                                        <td className="text-right">
                                                            <strong>${Math.round(parseFloat(factura.valor_bruto || 0)).toLocaleString('es-CO')}</strong>
                                                        </td>
                                                        <td className="text-right">
                                                            <strong>${Math.round(parseFloat(factura.valor_total)).toLocaleString('es-CO')}</strong>
                                                        </td>
                                                        <td className="text-right">
                                                            {(factura.estado === 2 || factura.estado === 5) ? (
                                                                <span className="total-pill total-pill--bad">
                                                                    ${Math.round(parseFloat(factura.valor_pendiente || factura.valor_total)).toLocaleString('es-CO')}
                                                                </span>
                                                            ) : (
                                                                <span className="total-pill total-pill--ok">$0</span>
                                                            )}
                                                        </td>
                                                        <td className="text-center text-capitalize">
                                                            {factura.tipo_pago || 'N/A'}
                                                        </td>
                                                        <td>
                                                            {getFormaPagoTexto(factura.forma_pago)}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={getDianChipClass(factura.estado)}>
                                                                {[1, 2, 3].includes(factura.estado) ? 'ENVIADO' : [4, 5].includes(factura.estado) ? 'NO APLICA' : 'NO ENVIADO'}
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span className={getEstadoChipClass(factura.estado)}>
                                                                {getEstadoTexto(factura.estado)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="15" className="text-center py-4 text-muted">
                                                            No se encontraron facturas con los filtros aplicados
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>
                </section>
            </div>
            <Footer />
        </div>
    );
}

export default ReporteFacturacion;